export const defaultQuestionObj = {
  'id': 0,
  'temp_id': -1001,
  'text': 'New Question',
  'applied_to_all_tickets': true,
  'applied_to_ticket_id': [],
  'ask_to': 'Purchaser',
  'display_type': 'TextBox',
  'options': [],
  'placement_index': 1,
  'help_text': '',
  'applied_to_ticket_temp_id': [-1001]
};
